<div class="cooking-container">
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/cookingbook/share.svg" alt="" />

      <p>افزودن به خانه</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-body">
    <p class="detail">لینک زیر را برای اعضای خانه خود ارسال کنید.</p>
    <div class="invite">
      <span> لینک دعوت </span>
      <p (click)="copy()">{{ this.url }}</p>
      <img (click)="copy()" src="assets/cookingbook/copy.svg" alt="" />
    </div>
    <div class="button" (click)="share()">
      <img src="assets/cookingbook/forward.svg" alt="" />
      اشتراک‌گذاری لینک دعوت
    </div>
  </div>
</div>
